/**
 * Created by Dhanya Akhil on 3/1/2017.
 */
import {Component, OnInit} from '@angular/core';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {AccountResourceService} from "../../../shared/services/account-resource.service";

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
  success = false;
  error = false;
  data;
  currentPassword:string;
  newPasswordVal:string;
  confirmPasswordVal:string;
  errorMessage:string = "Server Error";
  language:string;
  public lang;
  public browserLang;
  doNotMatch = false;
  message;
  errorERRCP000001:any = false;
  errorERRCP000002;
  errorERRCP000003;
  errorERRCP000004;
  errorERRCP000005;
  public updateStyle:boolean = false;
  public updateLabel:boolean = false;
  public updateCurrentPass:boolean = false;
  constructor(public accountResourceService:AccountResourceService, private translate:TranslateService) {
    this.lang = translate.currentLang;

    this.translate.onLangChange.subscribe((event:LangChangeEvent) => {
      this.browserLang = event.lang
      this.lang = this.browserLang;
    });
  }


  ngOnInit() {
  }

  public resetForgotPasswordErrors() {
    this.error = false;
    this.errorERRCP000001 = false;
    this.errorERRCP000002 = false;
    this.errorERRCP000003 = false;
    this.errorERRCP000004 = false;
    this.errorERRCP000005 = false;
  }

  changePassword() {
    if (this.newPasswordVal !== this.confirmPasswordVal) {
      this.error = null;
      this.success = null;
      this.doNotMatch = true;
    } else {
      this.error = false;
      this.success = false;
      this.doNotMatch = false;
      this.accountResourceService.changePassword({
        currentPassword: this.currentPassword,
        newPassword: this.newPasswordVal,
        confirmPassword: this.confirmPasswordVal,
        language: this.lang
      }).subscribe(
        data => {
          this.data = data;
          if (this.data.status == '200') {
            this.resetForgotPasswordErrors();
            this.success = true;
            this.message = this.data.message;
          } else {
            this.success = null;
            this.resetForgotPasswordErrors();
            if (this.data.status !== null || this.data.status !== undefined) {
              this['error' + this.data.status] = true;
              this.message = this.data.message;
            } else {
              this.error = true;
              this.message = this.data.message;
            }
          }
        },
        error => this.errorMessage = <any>error);
    }
  }
  updateLabelStyle(){
    if(this.newPasswordVal != ''){
      this.updateStyle = true;
    } else {
      this.updateStyle = false;
    }
  }
  updateLabelConfirmPasswordlabel(){
    if(this.confirmPasswordVal !=''){
      this.updateLabel = true;
    } else {
      this.updateLabel = false;
    }
  }
  updateCurrentPassLabelStyle(){
    if(this.currentPassword !=''){
      this.updateCurrentPass = true;
    } else {
      this.updateCurrentPass = false;
    }

  }
}
